"use strict";
/* tslint:disable: variable-name no-shadowed-variable */
Object.defineProperty(exports, "__esModule", { value: true });
var Rbar_97 = 8.314510; // [kJ/(kmol K)] = Universal molar gas constant
var R97 = 0.461526 * 1000; // [kJ/(kg K)] -> [J/(kg K)] = Specific gas constant
var M97 = 18.015257 / 1000; // [kg/kmol] -> [kg/mol] = Molar mass
//private const double rho_c = 322.0; // [kg/m3] = Critical mass density
//private const double T_c = 647.096; // [K] = Critical temperature
//private const double p_c = 22.064 * 1000 * 1000; // [MPa] -> [Pa] = Critical pressure
var pstar = 16.53 * 1000 * 1000; // [MPa] -> [Pa]
var Tstar = 1386; // [K]
var I = [
    NaN,
    0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2,
    3, 3, 3, 4, 4, 4, 5, 8, 8, 21, 23, 29, 30, 31, 32,
];
var J = [
    NaN,
    -2, -1, 0, 1, 2, 3, 4, 5, -9, -7, -1, 0, 1, 3, -3, 0, 1, 3, 17, -4, 0,
    6, -5, -2, 10, -8, -11, -6, -29, -31, -38, -39, -40, -41,
];
var n = [
    NaN,
    0.14632971213167, -0.84548187169114, -0.37563603672040E1, 0.33855169168385E1, -0.95791963387872,
    0.15772038513228, -0.16616417199501E-1, 0.81214629983568E-3, 0.28319080123804E-3, -0.60706301565874E-3,
    -0.18990068218419E-1, -0.32529748770505E-1, -0.21841717175414E-1, -0.52838357969930E-4, -0.47184321073267E-3,
    -0.30001780793026E-3, 0.47661393906987E-4, -0.44141845330846E-5, -0.72694996297594E-15, -0.31679644845054E-4,
    -0.28270797985312E-5, -0.85205128120103E-9, -0.22425281908000E-5, -0.65171222895601E-6, -0.14341729937924E-12,
    -0.40516996860117E-6, -0.12734301741641E-8, -0.17424871230634E-9, -0.68762131295531E-18,
    0.14478307828521E-19, 0.26335781662795E-22, -0.11947622640071E-22, 0.18228094581404E-23, -0.93537087292458E-25,
];
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K]</param>
/// <returns>Specific Enthalpy [J/kg]</returns>
function Get_Specific_Enthalpy_of_Liquid_Water(p, T) {
    //Specific Enthalpy of Liquid Water:
    //[1] eq. (2.69) and table 2.9:
    var pi = p / pstar;
    var tau = Tstar / T;
    var dgamma1_dtau_pi = Get_dgamma1_dtau_pi(tau, pi);
    var hliq = R97 * T * tau * dgamma1_dtau_pi;
    return hliq;
}
exports.Get_Specific_Enthalpy_of_Liquid_Water = Get_Specific_Enthalpy_of_Liquid_Water;
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K]</param>
/// <returns>Specific Volume [m3/kg_a]</returns>
function Get_Specific_Volume_of_Liquid_Water(p, T) {
    var pi = p / pstar;
    var dgamma_dpi = Get_dgamma1_dpi(p, T);
    var v_liq = R97 * T * pi / p * dgamma_dpi;
    return v_liq;
}
exports.Get_Specific_Volume_of_Liquid_Water = Get_Specific_Volume_of_Liquid_Water;
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K]</param>
/// <returns>Molar Volume [kg/mol]</returns>
function Get_Molar_volume_of_Liquid_Water(p, T) {
    var vbar_ws = M97 * Get_Specific_Volume_of_Liquid_Water(p, T);
    return vbar_ws;
}
exports.Get_Molar_volume_of_Liquid_Water = Get_Molar_volume_of_Liquid_Water;
/// <param name="T">Temperature [K]</param>
/// <returns>Saturation Pressure of Pure Water [Pa]</returns>
function Get_Saturation_Pressure_of_Pure_Water(T) {
    var upsilon_s = T - 0.23855557567849 / (T - 0.65017534844798E3);
    var A = Math.pow(upsilon_s, 2) + 0.11670521452767E4 * upsilon_s + -0.72421316703206E6;
    var B = -0.17073846940092E2 * Math.pow(upsilon_s, 2) + 0.12020824702470E5 * upsilon_s + -0.32325550322333E7;
    var C = 0.14915108613530E2 * Math.pow(upsilon_s, 2) + -0.48232657361591E4 * upsilon_s + 0.40511340542057E6;
    var p_ws = Math.pow((2 * C / (-B + Math.pow((Math.pow(B, 2) - 4 * A * C), 0.5))), 4);
    return p_ws * 1000 * 1000; // [MPa] -> [Pa]
}
exports.Get_Saturation_Pressure_of_Pure_Water = Get_Saturation_Pressure_of_Pure_Water;
/// <param name="p">Pressure [Pa]</param>
/// <returns>Temperature [K]</returns>
function Get_Saturation_Temperature_of_Water(p) {
    var n = [
        NaN,
        0.11670521452767E4, -0.72421316703206E6, -0.17073846940092E2, 0.12020824702470E5, -0.32325550322333E7,
        0.14915108613530E2, -0.48232657361591E4, 0.40511340542057E6, -0.23855557567849, 0.65017534844798E3,
    ];
    var pstar = 1 * 1000 * 1000; // [MPa] -> [Pa];
    var Tstar = 1; // [K]
    var beta = Math.pow(p / pstar, 0.25);
    var E = Math.pow(beta, 2) + n[3] * beta + n[6];
    var F = n[1] * Math.pow(beta, 2) + n[4] * beta + n[7];
    var G = n[2] * Math.pow(beta, 2) + n[5] * beta + n[8];
    var D = (2 * G) / (-F - Math.pow((Math.pow(F, 2) - 4 * E * G), 0.5));
    var T_s = Tstar * (n[10] + (D - Math.pow((Math.pow((n[10] + D), 2) - 4 * (n[9] + n[10] * D)), 0.5))) / 2;
    return T_s;
    //beta = Math.pow(p / 1000 / 1000, 0.25);
    //E = Math.pow(beta, 2) + n[3] * beta + n[6];
    //F = n[1] * Math.pow(beta, 2) + n[4] * beta + n[7];
    //G = n[2] * Math.pow(beta, 2) + n[5] * beta + n[8];
    //D = (2 * G) / (-F - Math.Sqrt(Math.pow(F, 2) - 4 * E * G));
    //double result = 0.5 * (n[10] + D - Math.Sqrt(Math.pow((n[10] + D), 2) - 4 * (n[9] + n[10] * D)));
    //return result;
}
exports.Get_Saturation_Temperature_of_Water = Get_Saturation_Temperature_of_Water;
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K]</param>
/// <returns>Isothermal Compressibility [1/Pa]</returns>
function Get_Isothermal_Compressibility_of_Liquid_Water(p, T) {
    var pi = p / pstar;
    // Calculate first derivative of the reduced Gibbs energy
    var d_gamma1_d_pi = Get_dgamma1_dpi(p, T);
    // Calculate second derivative of the reduced Gibbs energy
    var d2_gamma1_d_pi2 = Get_d2gamma1_dpi2(p, T);
    var result = -(1 / p) * pi * d2_gamma1_d_pi2 * Math.pow(d_gamma1_d_pi, -1);
    return result;
}
exports.Get_Isothermal_Compressibility_of_Liquid_Water = Get_Isothermal_Compressibility_of_Liquid_Water;
function Get_Ideal_Gas_Molar_Enthalpy_of_Water_Vapor_97(T) {
    // At temperatures T ≥ 273.15K use [1] eq. (3.47) and table 2.9
    var Tstar = 540; // [K]
    var tau = Tstar / T;
    var hbar0_97 = -0.01102142797; // [kJ/kmol]
    var dgammao2_dtau_pi = Get_dgammao2_dtau_pi(tau);
    var hbaro_w = hbar0_97 + Rbar_97 * T * tau * dgammao2_dtau_pi;
    return hbaro_w;
}
exports.Get_Ideal_Gas_Molar_Enthalpy_of_Water_Vapor_97 = Get_Ideal_Gas_Molar_Enthalpy_of_Water_Vapor_97;
function Get_dgamma1_dtau_pi(tau, pi) {
    var dgamma1_dtau_pi = 0;
    for (var i = 1; i <= 34; i++) {
        dgamma1_dtau_pi += n[i] * Math.pow((7.1 - pi), I[i]) * J[i] * Math.pow((tau - 1.222), (J[i] - 1));
    }
    return dgamma1_dtau_pi;
}
function Get_dgammao2_dtau_pi(tau) {
    var Jo = [NaN, 0, 1, -5, -4, -3, -2, -1, 2, 3];
    var no = [
        NaN,
        -0.96927686500217E1, 0.10086655968018E2, -0.56087911283020E-2, 0.71452738081455E-1, -0.40710498223928,
        0.14240819171444E1, -0.43839511319450E1, -0.28408632460772, 0.21268463753307E-1,
    ];
    var dgammao2_dtau_pi = 0;
    for (var i = 1; i <= 9; i++) {
        dgammao2_dtau_pi += no[i] * Jo[i] * Math.pow(tau, Jo[i] - 1);
    }
    return dgammao2_dtau_pi;
}
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K]</param>
/// <returns></returns>
function Get_dgamma1_dpi(p, T) {
    var pi = p / pstar;
    var tau = Tstar / T;
    var d_gamma1_d_pi = 0;
    for (var i = 1; i <= 34; i++) {
        d_gamma1_d_pi += -n[i] * I[i] * Math.pow(7.1 - pi, I[i] - 1) * Math.pow((tau - 1.222), J[i]);
    }
    return d_gamma1_d_pi;
}
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K]</param>
/// <returns></returns>
function Get_d2gamma1_dpi2(p, T) {
    var pi = p / pstar;
    var tau = Tstar / T;
    var d2gamma1_dpi2 = 0;
    for (var i = 1; i <= 34; i++) {
        d2gamma1_dpi2 += n[i] * I[i] * (I[i] - 1) * Math.pow(7.1 - pi, I[i] - 2) * Math.pow((tau - 1.222), J[i]);
    }
    return d2gamma1_dpi2;
}
